import { createFileRoute, useParams, Link } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { QueryBoundary } from '@/components/query-boundary';
import { PostForm } from '@/components/forms/PostForm';
import { Button } from '@/components/ui/button';
import { usePostQuery, useUpdatePost } from '@/lib/queries/posts';
import { ChevronLeft, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

export const Route = createFileRoute('/posts/$slug')({ component: EditPost });

function EditPost() {
  const { slug } = useParams({ from: '/posts/$slug' });
  const query = usePostQuery(slug);
  const update = useUpdatePost(slug);

  return (
    <>
      <div className="mb-3">
        <Button variant="ghost" size="sm" asChild className="-ml-2 text-muted-foreground">
          <Link to="/content" search={{ tab: 'posts', status: 'all', q: '', days: 30 }}>
            <ChevronLeft /> 글 목록
          </Link>
        </Button>
      </div>
      <PageHeader
        title="글 편집"
        description={slug}
        actions={
          <a href={`https://zerry.co.kr/blog/${slug}`} target="_blank" rel="noopener">
            <Button variant="outline" size="sm"><ExternalLink /> 보기</Button>
          </a>
        }
      />
      <QueryBoundary query={query}>
        {post => (
          <PostForm
            initial={post}
            submitLabel="저장"
            onSubmit={async v => {
              try { await update.mutateAsync(v); toast.success('저장됨'); }
              catch (e) { toast.error((e as Error).message); }
            }}
          />
        )}
      </QueryBoundary>
    </>
  );
}
